import { SelectionIndicatorSizeType, SelectionIndicatorVariantType, } from '../../../../../../components/selectionIndicator/types/selectionIndicator';
import { SelectionIndicatorStateType } from '../../../../../../components/selectionIndicator/types/state';
import { extraSmallIconCommonStyles, extraSmallParentContainerCommonStyles, mediumIconCommonStyles, mediumParentContainerCommonStyles, smallIconCommonStyles, smallParentContainerCommonStyles, } from '../commonStyles';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [SelectionIndicatorVariantType.DEFAULT]: {
            [SelectionIndicatorSizeType.MEDIUM]: {
                [SelectionIndicatorStateType.DEFAULT_SELECTED]: {
                    parentContainer: {
                        ...mediumParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_selected_bg_50,
                        border_color: FOUNDATIONS.color_neutral_border_static_50,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                    icon: {
                        ...mediumIconCommonStyles(FOUNDATIONS, FONT),
                        color: FOUNDATIONS.color_comp_resources_selectionindicator_default_selected_icon,
                    },
                },
                [SelectionIndicatorStateType.DEFAULT_UNSELECTED]: {
                    parentContainer: {
                        ...mediumParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_neutral_bg_375,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                },
                [SelectionIndicatorStateType.DISABLE_SELECTED]: {
                    parentContainer: {
                        ...mediumParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_300,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                    icon: {
                        ...mediumIconCommonStyles(FOUNDATIONS, FONT),
                        color: FOUNDATIONS.color_accent_disabled_icon_50,
                    },
                },
                [SelectionIndicatorStateType.DISABLE_UNSELECTED]: {
                    parentContainer: {
                        ...mediumParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                },
            },
            [SelectionIndicatorSizeType.SMALL]: {
                [SelectionIndicatorStateType.DEFAULT_SELECTED]: {
                    parentContainer: {
                        ...smallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_selected_bg_50,
                        border_color: FOUNDATIONS.color_neutral_border_static_50,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                    icon: {
                        ...smallIconCommonStyles(FOUNDATIONS, FONT),
                        color: FOUNDATIONS.color_comp_resources_selectionindicator_default_selected_icon,
                    },
                },
                [SelectionIndicatorStateType.DEFAULT_UNSELECTED]: {
                    parentContainer: {
                        ...smallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_neutral_bg_375,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                },
                [SelectionIndicatorStateType.DISABLE_SELECTED]: {
                    parentContainer: {
                        ...smallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_300,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                    icon: {
                        ...smallIconCommonStyles(FOUNDATIONS, FONT),
                        color: FOUNDATIONS.color_accent_disabled_icon_50,
                    },
                },
                [SelectionIndicatorStateType.DISABLE_UNSELECTED]: {
                    parentContainer: {
                        ...smallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                },
            },
            [SelectionIndicatorSizeType.EXTRA_SMALL]: {
                [SelectionIndicatorStateType.DEFAULT_SELECTED]: {
                    parentContainer: {
                        ...extraSmallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_selected_bg_50,
                        border_color: FOUNDATIONS.color_neutral_border_static_50,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                    icon: {
                        ...extraSmallIconCommonStyles(FOUNDATIONS, FONT),
                        color: FOUNDATIONS.color_comp_resources_selectionindicator_default_selected_icon,
                    },
                },
                [SelectionIndicatorStateType.DEFAULT_UNSELECTED]: {
                    parentContainer: {
                        ...extraSmallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_neutral_bg_375,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                },
                [SelectionIndicatorStateType.DISABLE_SELECTED]: {
                    parentContainer: {
                        ...extraSmallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_300,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                    icon: {
                        ...extraSmallIconCommonStyles(FOUNDATIONS, FONT),
                        color: FOUNDATIONS.color_accent_disabled_icon_50,
                    },
                },
                [SelectionIndicatorStateType.DISABLE_UNSELECTED]: {
                    parentContainer: {
                        ...extraSmallParentContainerCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        border_radius: FOUNDATIONS.radius_1000,
                        border_width: FOUNDATIONS.border_75,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=default.js.map